export default __webpack_public_path__ + "static/media/rightarrow.beca8649.svg";